export default function getPrettyNumber(num) {
  let numSign = num < 0 ? "-" : "";
  let absNum = Math.abs(num);
  if (absNum >= 1000) {
    absNum = Math.round(absNum);
    const exponents = ["", "K", "M", "B", "T"];
    const exponentIndex = Math.floor((("" + absNum).length - 1) / 3);
    let significantNum = absNum / Math.pow(1000, exponentIndex);
    significantNum = significantNum.toFixed(1);
    if (parseFloat(significantNum) % 1 === 0) {
      significantNum = Math.round(parseFloat(significantNum));
    }
    return numSign + significantNum + exponents[exponentIndex];
  } else {
    let significantNum = absNum.toPrecision(3);
    if (parseFloat(significantNum) % 1 === 0) {
      significantNum = Math.round(parseFloat(significantNum));
    }
    return numSign + significantNum;
  }
}
